// src/realtime/conversationDeliveryBuffer.ts

// Holds delivery events that arrive before the message exists in store
// key: messageId -> value: dialogueSlug
const pendingDeliveries = new Map<number, string>();

// Holds read events that arrive before the message exists in store
// key: messageId -> value: { dialogueSlug, readerIds }
const pendingReads = new Map<
  number,
  { dialogueSlug: string; readerIds: Set<number> }
>();

// -----------------------------------------------------------------------------
// Delivery buffer
// -----------------------------------------------------------------------------
export function bufferDelivery(messageId: number, dialogueSlug: string) {
  pendingDeliveries.set(messageId, dialogueSlug);
}

export function consumeDelivery(messageId: number) {
  const slug = pendingDeliveries.get(messageId);
  if (!slug) return null;
  pendingDeliveries.delete(messageId);
  return slug;
}

export function hasPendingDelivery(messageId: number) {
  return pendingDeliveries.has(messageId);
}

// -----------------------------------------------------------------------------
// Read buffer
// -----------------------------------------------------------------------------
export function bufferRead(
  messageId: number,
  dialogueSlug: string,
  readerId: number
) {
  const existing = pendingReads.get(messageId);

  if (existing) {
    existing.readerIds.add(readerId);
    return;
  }

  pendingReads.set(messageId, {
    dialogueSlug,
    readerIds: new Set([readerId]),
  });
}

export function consumeReads(messageId: number) {
  const entry = pendingReads.get(messageId);
  if (!entry) return null;

  pendingReads.delete(messageId);

  return {
    dialogueSlug: entry.dialogueSlug,
    readerIds: Array.from(entry.readerIds),
  };
}

export function hasPendingReads(messageId: number) {
  return pendingReads.has(messageId);
}